<template>
  <Modal
    v-model="reportModal"
    :title="title"
    width="80vw"
    class-name="pbr-personal-focus-modal"
    @on-ok="submit"
  >
    <div class="pbr">
      <div style="margin-bottom: 10px;">
        <AutoComplete
          clearable
          v-model="keywords"
          transfer
          @on-focus="
            () => {
              this.associationWordsList = [];
            }
          "
          @on-search="associationWords"
          :placeholder="placeholder"
          class="auto-complete"
          style="width: 90%;"
        >
          <Option
            v-for="item in associationWordsList"
            :value="item"
            :key="item"
            >{{ item }}</Option
          >
        </AutoComplete>

        <Button @click="getTable(1)" type="primary" style="">{{
          $t("buttons.search")
        }}</Button>
      </div>
      <Table
        v-if="isProject"
        class="pbr"
        border
        :columns="columns"
        :data="tableData"
        :loading="tableLoading"
        @on-row-click="rowClick"
        @on-sort-change="projectListTableSortChange"
        style="margin-top: 10px;"
      >
        <template slot-scope="{ row }" slot="favorites">
          <Icon
            color="#008acd"
            @click="editFavorite(row)"
            :type="row.focue ? 'md-star' : 'md-star-outline'"
            style="font-size: 20px;cursor: pointer"
          />
        </template>
        <template slot-scope="{ row }" slot="title">
          <span
            class="project-title"
            style="cursor:pointer"
            @click.stop="jumpProjectDetail(row)"
            v-html="row.title"
          ></span>
        </template>
      </Table>
      <Table
        v-if="!isProject"
        ref="infoTable"
        :show-header="false"
        :columns="infoColumns"
        :data="tableData"
        :loading="tableLoading"
      >
        <template slot-scope="{ row, index }" slot="title">
          <div class="newInfo-list-item">
            <div class="item-detail">
              <p
                class="item-detail-title"
                @click="goDetail(row)"
                v-html="row.title"
              ></p>
              <p class="item-detail-tag-box">
                <template>
                  <span style="color: #808c9a;font-size: 12px;">{{
                    row.articleFrom || ""
                  }}</span>
                  <Divider type="vertical" />
                </template>
                <span style="color: #808c9a;font-size: 12px;"
                  >{{ row.articleTime }}
                </span>
              </p>
            </div>
          </div>
        </template>
      </Table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :pager-count="5"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
        style="margin-top: 10px"
      >
      </el-pagination>
    </div>
  </Modal>
</template>
<script>
export default {
  name: "MoreProject",
  data() {
    return {
      searchForm: {
        orderby: "",
        orderkey: "",
      },
      title: "",
      placeholder: "",
      isProject: false,
      associationWordsList: [],
      keywords: "",
      tableLoading: false,
      currentPage: 1,
      specialId: "",
      pageSize: 10,
      tableData: [],
      tableTotal: 0,
      infoColumns: [
        // {
        //   type: "selection",
        //   width: 40,
        //   align: "center",
        // },

        {
          title: this.$t("table.project.main.title"),
          slot: "title",
        },
      ],
      columns: [],
      defaultColums: [
        {
          title: this.$t("table.project.main.title"),
          slot: "title",
          minWidth: 300,
          className: "table-head-style",
          fixed: `${this.isSmall ? "" : "left"}`,
        },
        {
          title: this.$t("table.project.main.industry"),
          key: "industry",
          width: 140,
          // sortable: true
          className: "table-head-style",
          sortable: "custom",
        },
        {
          title: this.$t("table.project.main.phrase"),
          key: "status",
          width: 120,
          // sortable: true
          className: "table-head-style",
          sortable: "custom",
        },
        {
          title: this.$t("table.project.main.type"),
          key: "category",
          width: 120,
          // sortable: true
          className: "table-head-style",
          sortable: "custom",
        },
        {
          title: this.$t("table.project.main.enterprise"),
          key: "enterprises",
          width: 300,
          // sortable: true
          className: "table-head-style",
          sortable: "custom",
          render: (h, params) => {
            return h(
              "span",
              params.row.enterprises && params.row.enterprises.length > 0
                ? params.row.enterprises.join("；")
                : ""
            );
          },
        },
        {
          title: this.$t("table.project.main.keyProject"),
          key: "weight",
          width: 120,
          // sortable: true
          className: "table-head-style",
          sortable: "custom",
          render: (h, params) => {
            return h(
              "span",
              params.row.weight === 1
                ? this.$t("table.project.main.yes")
                : this.$t("table.project.main.orNo")
            );
          },
        },
        {
          title: this.$t("table.project.main.country"),
          key: "country",
          width: 120,
          className: "table-head-style",
          // sortable: true
          sortable: "custom",
        },
        {
          title: this.$t("table.project.main.date"),
          key: "signDate",
          width: 130,
          align: "center",
          sortable: "custom",
          // render: (h, params) => {
          //   return h('span', self.$moment(params.row.pubDate).format('yyyy-MM-DD'))
          // }
        },
        {
          title: this.$t("table.project.main.amount"),
          key: "amount",
          width: 175,
          align: "right",
          // sortable: true
          className: "table-head-style",
          sortable: "custom",
        },
      ],
      reportModal: false,
    };
  },
  methods: {
    projectListTableSortChange(options) {
      let { column, key, order } = options;
      // 综合：zh 金额：je  行业：hy  状态：zt   国家：gj   日期：rq   默认是综合
      let orderkeyEnum = {
        amount: "je",
        industry: "hy",
        signDate: "rq",
        status: "zt",
        country: "gj",
      };
      if (order === "normal") {
        this.searchForm.orderby = "";
        this.searchForm.orderkey = "";
      } else {
        this.searchForm.orderby = order;
        this.searchForm.orderkey = orderkeyEnum[key];
      }
      this.getTable(1);
    },
    rowClick(row) {
      this.reportModal = false;
      this.$router.push({
        name: "pbrProjectDetail",
        params: row,
        query: { key: row.id },
      });
    },
    goDetail(row) {
      this.reportModal = false;
      this.$router.push({
        name: "pbrInfoDetail",
        params: row,
        query: { key: row.id, type: "project" },
      });
    },
    associationWords(keyword) {
      if (keyword && keyword.length > 100) {
        //this.$iMessage.error({content: this.$t('message.error.maximum100'), duration: 5})
        return;
      }
      // type（0项目搜索   1项目资讯搜索  2商机资讯搜索   3风险资讯搜索   4风险事件搜索  5分析页搜索）

      this.$pbrApis
        .associationWords({ keyword: keyword, type: 0 })
        .then((res) => {
          if (res.success) {
            this.associationWordsList = res.result.models;
          }
        });
    },
    open(val, id, projectColumn) {
      this.keywords = "";
      this.isProject = val === "1" ? true : false;
      this.title = this.isProject
        ? this.$t("tabs.special.more.projectTitle")
        : this.$t("tabs.special.more.infoTitle");
      this.placeholder = this.isProject
        ? this.$t("placeholders.project.search")
        : this.$t("placeholders.information.keywords");
      if (this.isProject) {
        console.log(projectColumn, "55555555555");
        this.columns = [];
        if (projectColumn === null) {
          this.columns = this.defaultColums;
        } else {
          projectColumn.forEach((item) => {
            if (item.key === "weight") {
              item.render = (h, params) => {
                return h(
                  "span",
                  params.row.weight === 1
                    ? this.$t("table.project.main.yes")
                    : this.$t("table.project.main.orNo")
                );
              };
            }
            if (item.key === "enterprises") {
              item.render = (h, params) => {
                return h(
                  "span",
                  params.row.enterprises && params.row.enterprises.length > 0
                    ? params.row.enterprises.join(",")
                    : ""
                );
              };
            }
            if (item.isShow == 1) {
              this.columns.push(item);
            }
          });
        }
      }
      this.specialId = id;
      this.getTable(1);
      this.reportModal = true;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTable();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTable();
    },
    getTable(val) {
      if (val) {
        this.currentPage = val;
      }
      this.tableLoading = true;
      //   this.$iSpin.show();
      let url = this.isProject
        ? "/front/project/search"
        : "/front/special/querySpecialNews";
      let param = this.isProject
        ? {
            specialId: this.specialId,
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            keywords: this.keywords,
            ...this.searchForm,
          }
        : {
            pageNo: this.currentPage,
            pageSize: this.pageSize,
            title: this.keywords,
            id: this.specialId,
          };
      if (this.isProject) {
        this.$pbrAxios
          .post(url, param)
          .then((data) => {
            if (data.success) {
              this.tableTotal = data.result.rows;
              this.tableData = data.result.models;
            } else {
              this.tableTotal = 0;
              this.tableData = [];
            }
            this.tableLoading = false;
          })
          .catch(() => {
            this.tableLoading = false;
          });
      }

      if (!this.isProject) {
        this.$pbrAxios
          .get(url, { params: param })
          .then((data) => {
            if (data.success) {
              this.tableTotal = data.result.total;
              this.tableData = data.result.records;
            } else {
              this.tableTotal = 0;
              this.tableData = [];
            }
            this.tableLoading = false;
          })
          .catch(() => {
            this.tableLoading = false;
          });
      }
    },
    submit() {
      this.reportModal = false;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ivu-table-row {
  cursor: pointer;
}
/deep/ .ivu-modal-body {
  max-height: calc(100vh - 300px);
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
